import { LayoutTypes } from '../../../../../../types/types';
import { AgendaItemListLayout } from './AgendaItemListLayout/AgendaItemListLayout';
import { AgendaItemOverlayLayout } from './AgendaItemOverlayLayout/AgendaItemOverlayLayout';
import { AgendaItemSideBySideLayout } from './AgendaItemSideBySideLayout/AgendaItemSideBySideLayout';
import { AgendaItemLayoutProps } from './const';

export const agendaItemLayoutFactory: {
  [key in LayoutTypes]: React.FC<AgendaItemLayoutProps>;
} = {
  [LayoutTypes.LIST]: AgendaItemListLayout,
  [LayoutTypes.SIDE_BY_SIDE]: AgendaItemSideBySideLayout, // Placeholder for card layout
  [LayoutTypes.OVERLAY]: AgendaItemOverlayLayout, // Placeholder for calendar layout
};
